import { chain } from "lodash"

export function getUserPreference(coll, type, defaultValue) {
  return chain(coll).find(pref => pref.type === type).get("value").value() || defaultValue
}
